/* eslint-disable no-undef */
(() => {
  if (!customElements.get("product-slider")) {
    class ProductSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.spaceBetween = 0;
      }

      connectedCallback() {
        this.swiperParent = this.querySelector(".swiper");
        this.nextBtn = this.parentElement.querySelector(".swiper-button-next");
        this.prevBtn = this.parentElement.querySelector(".swiper-button-prev");
        if (this.hasAttribute("data-space-between")) {
          this.spaceBetween = parseInt(this.getAttribute("data-space-between"), 10);
        }

        const mql = window.matchMedia("(max-width: 1028px)");
        if (!mql.matches) {
          this.createSwiper(); // Create Swiper instance when connected and not matching
        }

        mql.addEventListener("change", (e) => {
          if (e.matches) {
            this.destroySwiper(); // Destroy when media query matches
          } else {
            this.createSwiper(); // Create when media query no longer matches
          }
        });
      }

      disconnectedCallback() {
        this.destroySwiper(); // Ensure Swiper is destroyed when the component is disconnected
      }

      createSwiper() {
        if (!this.swiper) {
          this.swiper = new Swiper(this.swiperParent, {
            slidesPerView: this.getAttribute("slides-per-view") === "auto" ? "auto" : "5",
            spaceBetween: this.spaceBetween,
            slidesPerGroup: 5,
            resistance: true, // Enable resistance
            resistanceRatio: 0, // Prevent surpassing boundaries
            navigation:
              this.nextBtn && this.prevBtn
                ? {
                    nextEl: this.nextBtn,
                    prevEl: this.prevBtn,
                  }
                : undefined,
          });
        }
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }

    customElements.define("product-slider", ProductSlider);
  }
})();
